import type { FilesFormatSchemaWithId } from '@iconik-io/iconik-api/src/services/files';
import {
  CLOUD_STORAGE_METHODS,
  type StorageMethod,
} from '@iconik-io/shared-lib/src/utils/constants/storages';

const isAudioOrVideoFormat = (format: FilesFormatSchemaWithId): boolean =>
  Boolean(
    format.components?.some(
      (component) => component.type === 'VIDEO' || component.type === 'AUDIO',
    ),
  );

// Returns why an asset can't be published, or `undefined` when it can.
export function getPublishDisabledReason(
  mediaFormats: FilesFormatSchemaWithId[] | undefined,
  isTransferAndPublishSupported: boolean,
): 'NOT_AUDIO_OR_VIDEO' | 'NO_CLOUD_FORMAT' | undefined {
  if (!mediaFormats?.some(isAudioOrVideoFormat)) {
    return 'NOT_AUDIO_OR_VIDEO';
  }

  const publishableStorageMethods: StorageMethod[] =
    isTransferAndPublishSupported
      ? [...CLOUD_STORAGE_METHODS, 'FILE']
      : CLOUD_STORAGE_METHODS;
  const hasFormatOnPublishableStorage = mediaFormats.some(
    (format) =>
      format.is_online &&
      format.storage_methods?.some((method) =>
        publishableStorageMethods.includes(method),
      ) &&
      isAudioOrVideoFormat(format),
  );

  if (hasFormatOnPublishableStorage) {
    return undefined;
  }

  return 'NO_CLOUD_FORMAT';
}
